import { withStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ToolbarIcon = withStyles({
  root: {
    width: 'auto',
    height: 'auto',
  },
})(SvgIcon);

export default ToolbarIcon;
